<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to Settings" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="cutoff-tax-table" color="white"></help-link>
                    <v-btn v-if="hasEditRights&&!cutoff_settings" dark icon small title="Edit" @click="showEditSettings">
                        <v-icon small>edit</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            <v-alert v-if="!loading && cutoff_settings" :value="true" color="info" icon="info" outline dismissible>
                For security purposes, Payroll Settings will not be editable. Please contact support if need assistance.
            </v-alert>  
            <v-alert v-if="!loading && !cutoff_settings" :value="true" color="warning" icon="warning" outline style="margin:10px 20px 10px 20px;">
                Payroll Setting has not been set. Click Edit icon to update. Pleas note, this is a one time update only.
            </v-alert>
            <v-card v-if="!loading && cutoff_settings" class="elavation-1" style="margin:10px 0px 5px 0px;"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold">Cutoff Settings</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-layout row wrap style="padding:10px 20px 0px 20px;"> 
                            <v-flex xs4  class="text-xs-right">
                                Description :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">      
                                {{cutoff_settings.description}}
                            </v-flex>             
                        </v-layout>
                        <!-- for monthly -->
                        <v-layout v-if="!cutoff_settings.second_From && !cutoff_settings.second_To" row wrap style="padding:0px 20px 10px 20px;"> 
                            <v-flex xs4  class="text-xs-right">
                                Cutoff :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">      
                                {{cutoff_settings.first_From}} to {{cutoff_settings.first_To}}
                            </v-flex>             
                        </v-layout>

                        <!-- for semi-monthly -->
                        <v-layout v-if="cutoff_settings.second_From && cutoff_settings.second_To" row wrap style="padding:0px 20px 0px 20px;"> 
                            <v-flex xs4  class="text-xs-right">
                                1st Cutoff :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">      
                                {{cutoff_settings.first_From}} to {{cutoff_settings.first_To}}
                            </v-flex>             
                        </v-layout>
                        <v-layout v-if="cutoff_settings.second_From && cutoff_settings.second_To" row wrap style="padding:0px 20px 10px 20px;"> 
                            <v-flex xs4  class="text-xs-right">
                                2nd Cutoff :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">      
                                {{cutoff_settings.second_From}} to {{cutoff_settings.second_To}}
                            </v-flex>             
                        </v-layout>
                    </v-flex>                    
                </v-layout>
            </v-card>
            <v-card v-if="!loading && cutoff_settings" class="elavation-1" style="margin:10px 0px 5px 0px;"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold">Payroll Settings</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-layout row wrap style="padding:10px 20px 0px 20px;"> 
                            <v-flex xs4  class="text-xs-right">
                                Tax Table Type :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">      
                                {{cutoff_settings.taxTableType}}
                            </v-flex>             
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap style="padding:0px 20px 0px 20px;"> 
                            <v-flex xs4  class="text-xs-right">
                                Salary Type : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">      
                                {{ salaryType }}
                            </v-flex>             
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap style="padding:0px 20px 10px 20px;"> 
                            <v-flex xs4  class="text-xs-right">
                                <!-- TODO add this as part of initial setup -->
                                Contribution Schedule : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">      
                                {{ contributionScheduleDescription }}
                            </v-flex>             
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogSet" persistent width="600">
            <cutoff-settings ref="addEditSchedule" :dialogSet.sync="dialogSet" @send="getCutOffSettings"></cutoff-settings>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import common from '@/common/functions'
import commonData from '@/common/data'
import cutOffApi from '@/api/cutoff'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'

export default {     
    name: 'CompanyCutoff',
    metaInfo: {
        title: 'Company Account',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View / Edit Company Cutoff' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'cutoff-settings': () => import('@/components/CutOff/CutOffSettings'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            toggle_view: 4,
            cutoff_settings: null,
            dialogSet: false,
        }
    },
    methods: {    
        updateHandler(data) {
            if (data!=this.$store.state.userId) {
                this.getCutOffSettings(false)
            }
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },
        showEditSettings() {
            this.dialogSet = true
        },
        viewCompanySettings() {
            this.$router.push('/company/settings')
        },   
        async getCutOffSettings(show_loading) {
            try {
                this.loading = show_loading
                const response = await cutOffApi.getSettings()
                if (response && response.status == 200) {
                    this.cutoff_settings = response.data.item
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Settings'
        })

        this.getCutOffSettings(true)
    },
    computed: {
        hasEditRights() {
            return common.hasEditRights(this.$router.currentRoute.path)
        },
        companyIdStr() {
            return this.$store.state.companyId
        },
        pageQueryId() {
            return `${this.companyIdStr}_cutoff_settings`
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.cutoff,
                    notificationTypeId: notificationTypes.cutoff_settings
                }
            }
        },
        salaryType() {
            if (this.cutoff_settings) {
                return commonData.salary_types.filter(x => x.salaryType == this.cutoff_settings.salaryType)[0].name
            }
        },
        contributionScheduleDescription() {
            if (this.cutoff_settings) {
                return commonData.contribution_schedule_types.filter(x => x.contributionSchedule == this.cutoff_settings.contributionSchedule)[0].name
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>